import { useDonations } from 'features/cart/hooks/use-donations';
import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';
import { useUtensils } from 'features/cart/hooks/use-utensils';
import { EnvItem } from 'features/diagnostics/components/env-item';
import { View } from 'react-native';

import { CartDebugItem } from './cart-debug-item';

export const CartContentDebug = () => {
  const { cartEntries } = useMinimalCart();
  const { isUtensilsSectionEnabled } = useUtensils();
  const { isDonationsEnabled } = useDonations();

  return (
    <View style={{ paddingVertical: 10 }}>
      <View style={{ flexDirection: 'row', marginBottom: 10 }}>
        <View style={{ width: '50%', paddingRight: 6 }}>
          <EnvItem envKey="Utensils Enabled" value={isUtensilsSectionEnabled ? 'YES' : 'NO'} />
        </View>

        <View style={{ width: '50%', paddingLeft: 6 }}>
          <EnvItem envKey="Donations Enabled" value={isDonationsEnabled ? 'YES' : 'NO'} />
        </View>
      </View>

      {cartEntries.map(entry => (
        <CartDebugItem key={entry.cartId} cartEntry={entry} />
      ))}
    </View>
  );
};
